import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  startIcon: {
    marginRight: 0,
    color: theme.palette.text.primary,
  },
  colorPreview: {
    width: 24,
    height: 24,
  },
}))
